.success {
    color: var(--green);
}
